module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AkbCSEONG4ApgAAALZJREFUOMtjYBgFgwwoyckHqsgrJOKWl1NRkpefhizGhMxhZGR48J+BYZ6irFwxhmZ5OQ1GRqbzjP8ZHuN1hbKcopWSvMJ/JTnFKJiYvKycuLK8whtFeYWl6OoZsRoir+DAwMCwn4GBIZr5N9P2v6z/bv1jYFh//+GDNKIMYGBgYFCUl3di+Pd/LyMj0xNGhn8X7z565INNHTMuAz58/HhfSEDgLCMjo/iHv38Dv3/+9H80mWEHAFxcLtq0p2COAAAAAElFTkSuQmCC"


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/arrowdown.png
 ** module id = 245
 ** module chunks = 0 1
 **/